
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiBadgeGrid extends Serenity.EntityGrid<ProdottiBadgeRow, any> {
        protected getColumnsKey() { return ProdottiBadgeColumns.columnsKey; }
        protected getDialogType() { return ProdottiBadgeDialog; }
        protected getIdProperty() { return ProdottiBadgeRow.idProperty; }
        protected getInsertPermission() { return ProdottiBadgeRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiBadgeRow.localTextPrefix; }
        protected getService() { return ProdottiBadgeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}